import { Box, Button, Grid, Grow, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { deleteAllParticipants, deleteParticipant, getParticipants } from './AdminMenusRequests';
import AddIcon from '@mui/icons-material/Add';
import { SmallModal } from '../../CustomModal/SmallModal';
import { AddParticipant } from './modal/AddParticipant';
import { grey } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import { UpdateParticipant } from './modal/UpdateParticipant';
export const Participants = () => {
    const [participants,setParticipants] = useState([])
    const [maleParticipants,setMaleParticipants] = useState([])
    const [femaleParticipants,setFemaleParticipants] = useState([])
    const [selectedParticipant,setSelectedParticipant] = useState()
    useEffect(()=>{
        _init();
    },[])
    const _init = async () => {
        const res = await getParticipants()
        setParticipants(res.data.data)
        setMaleParticipants(res.data.male)
        setFemaleParticipants(res.data.female)
    }
    const [openAddModal,setOpenAddModal] = useState(false)
    const [openUpdateModal,setOpenUpdateModal] = useState(false)
    const handleReset = async () => {
        Swal.fire({
            icon:'question',
            title:'Confirm Deleting All Participants?',
            text:'All participants will be deleted. This action cannot be reverted.',
            confirmButtonText:'Yes, I confirm deletion',
            cancelButtonText:'No, Cancel deletion',
            showCancelButton:true
        }).then(async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Deleting all participants')
                const res = await deleteAllParticipants()
                if(res.data.status === 200){
                    setParticipants(res.data.data.data)
                    toast.success(res.data.message,{
                        id:toastId
                    })
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    })
                }
            }
        })
    }
    const handleDelete = async (item) => {
        const toastId = toast.loading('Deleting participant')
        const res = await deleteParticipant({id:item.id})
            if(res.data.status === 200){
                setParticipants(res.data.data.data)
                toast.success(res.data.message,{
                    id:toastId
                })
            }else{
                toast.error(res.data.message,{
                    id:toastId
                })
            }
    }
    const handleUpdate = (item) => {
        setSelectedParticipant(item);
        setOpenUpdateModal(true)
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography>Participants</Typography>
                <Box sx={{display:'flex',gap:1}}>
                    <Button variant='outlined' color='secondary' startIcon={<RestartAltIcon/>} onClick={handleReset}>Reset Participants</Button>
                    <Button variant='outlined' startIcon={<AddIcon/>} onClick={()=>setOpenAddModal(true)}>Add</Button>
                </Box>

            </Grid>
            <Grid item xs={12}>
                <Grow in>
                    <Paper>
                        <TableContainer sx={{maxHeight:'70vh',overflow:'auto'}}>
                            <Table stickyHeader>
                                <TableHead sx={{background:grey[100]}}>
                                    <TableRow>
                                        <TableCell>
                                            Number
                                        </TableCell>
                                        <TableCell>
                                            Name
                                        </TableCell>
                                        <TableCell>
                                            Office
                                        </TableCell>
                                        <TableCell>
                                            Sex
                                        </TableCell>
                                        <TableCell>

                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        participants.map((item)=>
                                            <TableRow key = {item.id} hover>
                                                <TableCell>
                                                    {item.number}
                                                </TableCell>
                                                <TableCell>
                                                    {item.name}
                                                </TableCell>
                                                <TableCell>
                                                    {item.office}
                                                </TableCell>
                                                <TableCell>
                                                    {item.sex}
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <Box sx={{display:'flex',gap:1}}>
                                                    <Tooltip title='Update'><IconButton color='success' className='icon-btn-bordered' onClick={()=>handleUpdate(item)}><EditIcon/></IconButton></Tooltip>
                                                    <Tooltip title='Delete'><IconButton color='error' className='icon-btn-bordered' onClick={()=>handleDelete(item)}><DeleteIcon/></IconButton></Tooltip>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <SmallModal open = {openAddModal} close = {()=>setOpenAddModal(false)} title='Adding new Participants'>
                <AddParticipant close = {()=>setOpenAddModal(false)} setParticipants = {setParticipants} setMaleParticipants={setMaleParticipants} setFemaleParticipants = {setFemaleParticipants} participants={participants}/>
            </SmallModal>
            <SmallModal open = {openUpdateModal} close = {()=>setOpenUpdateModal(false)} title='Adding new Participants'>
                <UpdateParticipant close = {()=>setOpenUpdateModal(false)} setParticipants = {setParticipants} participants={participants} selectedParticipant = {selectedParticipant}/>
            </SmallModal>
        </Grid>
    )
}